import axiosInstance, { errorHandler } from "./api";

// No permission
const getKeyholderSecretKeyStatus = axios => id =>
  axios
    .get(`/tps/api/check/secretKey/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// No permission
const getKeyholdersList = axios => () =>
  axios
    .get("/tps/api/keyholders/secrets")
    .then(({ data }) => data)
    .catch(errorHandler);

// No permission
const checkSecretKeyCorrectness = axios => secret => {
  return axios
    .post("/tps/api/keyholders/secrets/check", { secret })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// No permission
const getSaltAndAeskey = axios => () => {
  return axios
    .get("/tps/api/keyholders/account")
    .then(({ data }) => data)
    .catch(errorHandler);
};

// No permission
const submitSecretKeyHash = axios => secret => {
  return axios
    .post("/tps/api/keyholders/secrets", { secret })
    .then(({ data }) => data)
    .catch(errorHandler);
};

// No permission
const createBankAccountRequest = axios => () => {
  return axios
    .post("/tps/api/keyholders/account")
    .then(({ data }) => data)
    .catch(errorHandler);
};

// No permission
const getStatusOfBankAccountCreation = axios => () => {
  return axios
    .get("/tps/api/keyholders/account/status")
    .then(({ data }) => data)
    .catch(errorHandler);
};

// returns status "INSTALLATION" | "INSTALLED" | "RE_INSTALLATION" | "NO_WRITE_PERMISSION" | "RESEND_SECRETS"
const getStatusOfCurrentCase = axios => () => {
  return axios
    .get("/tps/api/keyholders/fast-client/status")
    .then(({ data }) => data)
    .catch(errorHandler);
};

// No permission
const createBankAccountRepeatRequest = axios => () => {
  return axios
    .post("/tps/api/keyholders/account/resend")
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  getKeyholderSecretKeyStatus: getKeyholderSecretKeyStatus(axiosInstance),
  getKeyholdersList: getKeyholdersList(axiosInstance),
  checkSecretKeyCorrectness: checkSecretKeyCorrectness(axiosInstance),
  getSaltAndAeskey: getSaltAndAeskey(axiosInstance),
  submitSecretKeyHash: submitSecretKeyHash(axiosInstance),
  createBankAccountRequest: createBankAccountRequest(axiosInstance),
  getStatusOfBankAccountCreation: getStatusOfBankAccountCreation(axiosInstance),
  getStatusOfCurrentCase: getStatusOfCurrentCase(axiosInstance),
  createBankAccountRepeatRequest: createBankAccountRepeatRequest(axiosInstance),
};
